/* eslint-disable @typescript-eslint/no-empty-object-type */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-unsafe-function-type */
// 2) Third-party libraries
import { createSlice, PayloadAction, createAction, createSelector } from "@reduxjs/toolkit";

// 3.3 Project-specific modules � components/types
import {
    SmsCustomization,
    SmsCustomizationState,
    SmsProviderActionTypes,
    RequestSaveCompanySmsCustomizationItemPayload,
} from "./types";

// 3.5 Redux actions / store
import type { RootState } from "../storeTypes";

const actionPrefix = 'smsProviders';

// Type-safe initialState!
export const initialState: SmsCustomizationState = {
    data: {
        Items: [],
        SelectedItemId: '',
        IsCustomizeSms: false
    },
    errorMessages: [],
    loading: false,
    saveLoading: false,
};

const smsProvidersSlice = createSlice({
    name: actionPrefix,
    initialState,
    reducers: {
        getSmsCustomizationProviderRequestAction: (state) => {
            state.loading = true;
        },
        getSmsCustomizationProviderSuccessAction: (
            state,
            action: PayloadAction<SmsCustomization>
        ) => {
            state.loading = false;
            state.data = action.payload;
        },
        getSmsCustomizationProviderFailAction: (state) => {
            state.loading = false;
        },
        saveSmsCustomizationProviderRequestAction: (
            state,
            _action: PayloadAction<RequestSaveCompanySmsCustomizationItemPayload>
        ) => {
            state.saveLoading = true;
        },
        saveSmsCustomizationProviderResponseAction: (state) => {
            state.saveLoading = false;
        }
    }
});

const { actions, reducer } = smsProvidersSlice;

// Actions
export const {
    getSmsCustomizationProviderRequestAction,
    getSmsCustomizationProviderSuccessAction,
    getSmsCustomizationProviderFailAction,
    saveSmsCustomizationProviderRequestAction,
    saveSmsCustomizationProviderResponseAction
} = actions;

// Selectors
export const getSmsProviderState = (state: RootState) => state.smsProviders;

// Reducer
export default reducer;